import React from 'react'
import { Link } from 'react-router-dom'
import GallerySection from '../components/GallerySection'
import { imageUrl } from '../lib/images'

export default function HelstegtPattegrisPage() {
  return (
    <div className="space-y-0">
      {/* Header / Intro */}
      <section className="bg-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#241F1C] tracking-tight leading-tight">
              Helstegt pattegris – gæsternes favorit
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-[#6E635C] leading-relaxed">
              Vores helstegte pattegris er det oplagte valg, når du vil forkæle dine gæster med et festmåltid,
              de sent vil glemme. Grillmesteren ankommer med alt nødvendigt udstyr og tilbereder grisens møre
              kød og sprøde svær direkte på stedet.
            </p>

            <div className="pt-2 flex flex-wrap gap-3 sm:gap-4">
              <Link
                to="/bestil"
                className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-2.5 sm:px-7 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
              >
                <i className="fa-solid fa-utensils text-xs sm:text-sm" aria-hidden="true" />
                <span>Sammensæt din pattegris-menu</span>
              </Link>
              <a
                href="tel:25752724"
                className="inline-flex items-center gap-2 bg-transparent text-[#241F1C] border border-[#241F1C]/40 px-5 py-2.5 sm:px-6 sm:py-3.5 font-bold text-xs sm:text-sm transition-colors whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-[#C25E27]" aria-hidden="true" />
                <span>25 75 27 24</span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden aspect-[4/3]">
              <img
                src={imageUrl('/_assets/img-4538.jpeg', 'width=800,quality=80,format=auto')}
                alt="Saftig helstegt pattegris med sprød svær på grill"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* PRICING & PACKAGES FROM FESTGRISEN SOURCE */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#241F1C]">
              Vælg mellem grillgris med eller uden tilbehør
            </h2>
            <p className="mt-2 text-xs sm:text-sm text-[#6E635C]">
              Altid inklusiv leje af professionel grill, stegning hos jer og udskæring for gæsterne.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Pakke 1 */}
            <div className="bg-white p-8 shadow-md flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl">
              <div>
                <h3 className="text-2xl font-bold text-[#241F1C]">1. Uden tilbehør</h3>
                <div className="mt-4 mb-6">
                  <div className="text-3xl font-black text-[#241F1C]">
                    149 kr. <span className="text-sm font-normal text-[#6E635C]">/ kuvert</span>
                  </div>
                  <div className="text-xs font-semibold text-[#6E635C] mt-1">Min. 45 personer</div>
                </div>

                <ul className="space-y-3 text-sm text-[#241F1C] border-t border-[#E6DFD5] pt-6">
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Helstegt pattegris marineret med specialkrydderier</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Inkl. professionel grill og udstyr</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Stegning på jeres adresse i 5-7 timer</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Udskæring ved buffeten af erfaren grillmester</span>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-[#E6DFD5]">
                <Link
                  to="/bestil"
                  className="w-full text-center block bg-[#241F1C] hover:bg-[#38322E] text-white py-2.5 sm:py-3 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg"
                >
                  Vælg denne løsning
                </Link>
              </div>
            </div>

            {/* Pakke 2 */}
            <div className="bg-white p-8 shadow-md flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl">
              <div>
                <h3 className="text-2xl font-bold text-[#241F1C]">2. Komplet Festmenu</h3>
                <div className="mt-4 mb-6">
                  <div className="text-3xl font-black text-[#241F1C]">
                    125 kr. <span className="text-sm font-normal text-[#6E635C]">/ kuvert + tilbehør</span>
                  </div>
                  <div className="text-xs font-semibold text-[#6E635C] mt-1">
                    Min. 45 personer (+84 kr. for 2 kartofler, 2 salater, brød &amp; smør)
                  </div>
                </div>

                <ul className="space-y-3 text-sm text-[#241F1C] border-t border-[#E6DFD5] pt-6">
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Helstegt pattegris marineret og tilberedt på stedet</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Inkl. leje af grill og udskæring af grillmester</span>
                  </li>
                  <li className="flex items-center gap-3 font-semibold text-[#241F1C]">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>2 valgfrie kartoffelretter (f.eks. flødekartofler)</span>
                  </li>
                  <li className="flex items-center gap-3 font-semibold text-[#241F1C]">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>2 valgfrie friske salater</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-check text-[#C25E27] text-xs" aria-hidden="true" />
                    <span>Friskbagt sprødt brød og smør</span>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-[#E6DFD5]">
                <Link
                  to="/bestil"
                  className="w-full text-center block bg-[#C25E27] hover:bg-[#A84E1C] text-white py-2.5 sm:py-3 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
                >
                  Sammensæt menu i guiden
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DETAIL BENEFITS */}
      <section className="bg-white py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="overflow-hidden aspect-[4/3]">
            <img
              src={imageUrl('/_assets/img-4783.jpeg', 'width=800,quality=80,format=auto')}
              alt="Grillmester udskærer pattegris"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#241F1C]">
              En professionel grillmester med sans for detaljen
            </h2>
            <div className="space-y-4 text-sm sm:text-base text-[#6E635C] leading-relaxed">
              <p>
                Kunne du tænke dig at forkæle dig selv og alle dine gæster med en helstegt pattegris til din
                næste fest? Hos Overgaard Pattegrise får du en komplet oplevelse med saftig grillgris, sprød
                svær og professionel service fra erfarne grillmestre, der kommer med ud og hjælper på selve dagen.
              </p>
              <p>
                Vi sørger for, at alt klapper på dagen. Vi møder op i god tid, tænder op for den specielle
                rotisserie-grill og overvåger tilberedningen hele vejen igennem, så kødet når den perfekte
                kernetemperatur, og sværen popper sprødt.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
              <div>
                <h4 className="font-bold text-sm text-[#241F1C]">11 forskellige salater</h4>
                <p className="text-xs text-[#6E635C] mt-1">
                  Fra klassisk kartoffelsalat til moderne spidskålssalat med æble og granatæble.
                </p>
              </div>
              <div>
                <h4 className="font-bold text-sm text-[#241F1C]">4 slags kartofler</h4>
                <p className="text-xs text-[#6E635C] mt-1">
                  Vælg frit mellem cremede flødekartofler, ovnstegte kartofler eller kolde kartoffelsalater.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Galleri */}
      <GallerySection
        gallerySlug="helstegt-pattegris-galleri"
        title="Galleri – Helstegt pattegris"
        subtitle="Se hvordan det ser ud, når vi tænder op for grillen hos vores kunder."
      />
    </div>
  )
}
